import { Injectable } from '@angular/core';
import { UserRole } from '@reenstudio/app/core/enum/user-role';
import { AbstractApiService } from '@reenstudio/app/core/services/api/abstract-api.service';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import {
  UserAddEditApiRequest,
  UserApiPostResponseData,
  UserListApiResponse,
} from '@reenstudio/app/core/models/api/user/user-api-model';
import { Observable } from 'rxjs';
import { UserModel } from '../../models/user/user-model';

@Injectable({
  providedIn: 'root',
})
export class UserApiService extends AbstractApiService {
  private readonly endpoint = '/users';

  constructor(
    protected override http: HttpClient,
    protected override logger: NGXLogger
  ) {
    super(http, logger);
  }

  getUsers(params: { userId?: number; userName?: string }) {
    return this.fetch<UserListApiResponse>(`${this.endpoint}`, params, true);
  }

  getUser(id: string) {
    return this.fetch<UserModel>(`${this.endpoint}/${id}`);
  }

  addUser(data: UserAddEditApiRequest): Observable<UserApiPostResponseData> {
    return this.post<UserAddEditApiRequest, UserApiPostResponseData>(
      `${this.endpoint}`,
      data
    );
  }

  editUser(id: string, data: UserAddEditApiRequest) {
    return this.patch<UserAddEditApiRequest, string>(
      `${this.endpoint}/${id}`,
      data
    );
  }

  // deleteUser(id: number) {
  //   return this.delete<number>(`${this.endpoint}/${id}`);
  // }

  deleteUser(id: number) {
    return this.delete<number>(`${this.endpoint}/${id}`);
  }
}
